import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../icon/Icon';
import styles from './states.module.css';
export function ErrorPanel({ message, onRetry }) {
    return (_jsxs("div", { className: styles.error, role: "alert", children: [_jsxs("span", { className: styles.errorHead, children: [_jsx(Icon, { name: "unsure" }), "Something didn\u2019t load"] }), _jsx("span", { children: message ?? 'We couldn’t load this just now.' }), onRetry ? (_jsx("button", { type: "button", className: styles.primaryBtn, onClick: onRetry, children: "Try again" })) : null] }));
}
//# sourceMappingURL=ErrorPanel.js.map